
namespace GeniuzPOS.InitialData {
    @Serenity.Decorators.registerClass()
export class PsCustomerSurveyDtEditor extends Serenity.Extensions.GridEditorBase<PsCustomerSurveyDtRow> {
    protected getColumnsKey() { return PsCustomerSurveyDtColumns.columnsKey; }
    protected getDialogType() { return PsCustomerSurveyDtDialog; }
    protected getLocalTextPrefix() { return PsCustomerSurveyDtRow.localTextPrefix; }

    public myPassValue: string;

    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
           buttons.push(
                {
                    title: Q.text("สร้างรายการ"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {

                       
                            // console.log(this.supid)
                            // console.log(this.supid +"sup" + this.whsid)
                            this.createEntityDialog(this.getItemType(), dlg => {


                                var dialog = dlg as PsCustomerSurveyDtDialog;
                                dialog.onSave = (opt, callback) => this.save(opt, callback);
                                var entity = this.getNewEntity() as PsCustomerSurveyDtRow;

                                entity.SurveyCode = this.myPassValue
                                // entity.SupplierId = this.supid
                                // entity.WhsId = this.whsid
                                // entity.SalesVatTypes = this.salevattype
                                // entity.ShopId = this.shopid



                                dialog.loadEntityAndOpenDialog(entity, false);
                            }

                            );
                       
                    },
                }
            );
       
        return buttons;
    }


    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

    protected usePager() {
        return false;
    }

    
}}